import { storiesOf } from '@storybook/vue';
import { withKnobs, text } from '@storybook/addon-knobs';


const stories = storiesOf('Components/DMS/Form', module);

stories
	.addDecorator(withKnobs)
	.add('Label', () => ({
		template: '<dms-label v-bind="$props"/>',
		methods: {},
		props: {
			text: {
				default: text('Text', 'Label'),
			},
		},
	}));
